import styled from "styled-components";


export const Wrapper = styled.div`
width: 96%;
display: flex;
justify-content: flex-end;
align-items: center;

`

export const Body = styled.div`
/* width:18%; */
display: flex;
justify-content:space-between;
align-items: center;

`